import { envConfig } from '@/shared/config/env'

const normalizeUrl = (value: string | undefined, fallback: string) => {
  const trimmed = String(value || '').trim()
  return trimmed || fallback
}

const normalizeBaseUrl = (value: string | undefined, fallback: string) =>
  normalizeUrl(value, fallback).replace(/\/$/, '')

const OFFICIAL_WEBSITE_BASE_URLS = {
  development: 'http://127.0.0.1:3001',
  test: 'https://test.8nfueloi.easyhireai.com',
  production: 'https://easyhireai.com',
} as const

const officialWebsiteBaseUrl =
  OFFICIAL_WEBSITE_BASE_URLS[import.meta.env.MODE as keyof typeof OFFICIAL_WEBSITE_BASE_URLS] ||
  OFFICIAL_WEBSITE_BASE_URLS.production

export const websiteLinks = {
  officialWebsite: officialWebsiteBaseUrl,
  blog: `${officialWebsiteBaseUrl}/blog`,
  chromeExtension:
    'https://chromewebstore.google.com/detail/oiilonnoeenhflnpndfcfalpkhmidgfo?utm_source=item-share-cb',
  contactSalesEmail: 'mailto:chris@easyhireai.com',
  contactSalesEmailAddress: 'chris@easyhireai.com',
  userCenterDocs: 'https://hire-mokahr.dochelp.cn/index.html',
  social: {
    x: 'https://x.com/ClementHu666',
    facebook: 'https://www.facebook.com/profile.php?id=61570754292849',
    youtube: 'https://www.youtube.com/@clementHu-EasyHireAI/posts',
    linkedin: 'https://www.linkedin.com/company/easyhireaitool/',
    xhs: 'https://www.xiaohongshu.com/user/profile/5b73abf3181e220001701aaa?xhsshare=userQrCode&wechatWid=c59ac84efa4f417554fe1b8b5f125e3b&wechatOrigin=menu',
  },
  externalTools: {
    aiSourcing: 'https://bate.easyhireai.com/',
    linkedinPeopleSearch: 'https://www.linkedin.com/search/results/people',
    linkedinSalesNavigatorSearch: 'https://www.linkedin.com/sales/search/people',
    linkedinRecruiterSearch: 'https://www.linkedin.com/talent/search',
  },
  auth: {
    passwordAccountCenter: `${normalizeBaseUrl(envConfig.logtoEndpoint, 'https://auth.easyhireai.com')}/account/password`,
  },
} as const
